<div class="container bg-dark p-5 position-relative">
    <div class="row">
        <div class="col-12">
            <p class="text-center mt-3 h5">
                {{dialogText}}
            </p>
            <div class="d-flex justify-content-around mt-5">
                <button class="btn px-3 px-md-5" (click)="closeDialog()">No</button>
                <button class="btn px-3 px-md-5" (click)="deleteAndClose()">Yes</button>
            </div>
        </div>
    </div>
    <!-- close icon -->
    <div>
        <i mat-button mat-dialog-close class="bi bi-x-circle-fill close-icon h3 position-absolute"></i>
    </div>
</div>